import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import ChaplinDashboard from 'images/ChaplaincyDashboard.png';
export default function ChaplinDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('chaplaincydashboardText', { ns: ['home'] })}</Typography>
      <img src={ChaplinDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}
